var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 203 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.6,54.2l19-48.4H58l15.5,48.4H127.6z M102.3,252.3c53,0,96.2-43.2,96.2-96.2c0-37.4-21.3-69.7-52.4-85.8H57.4 C26.3,86.4,5.6,118.7,5.6,156.1C5.6,209.1,48.7,252.3,102.3,252.3z M97.1,167.6c-14.4-4.6-24.2-11.5-24.2-24.8 c0-12.1,8.6-21.3,23-24.2V106h13.2v12.1c9.2,0.6,15,2.3,19.6,4.6l-4,15c-3.5-1.7-9.8-4.6-19.6-4.6c-8.6,0-11.5,4-11.5,7.5 c0,4.6,4.6,7.5,16.1,11.5c16.1,5.8,22.5,13.2,22.5,25.3c0,12.1-8.6,22.5-24.2,24.8V216H94.8v-12.7c-9.2-0.6-17.9-2.9-23-5.8l4-15.5 c5.8,2.9,13.8,5.8,22.5,5.8c7.5,0,12.7-2.9,12.7-8.6C111.5,174,106.9,171.1,97.1,167.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.04ea152b.svg";
export { ForwardRef as ReactComponent };